
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cloud/preview/[filename]",
      function () {
        return require("private-next-pages/cloud/preview/[filename].tsx");
      }
    ]);
  